export interface CreateNoteRequest {
  clientId: number;
  note: string;
  createdByUserId: number;
  noteType: NoteType;
}

export enum NoteType {
  Admin = 1,
  Step = 2,
  Milestone = 3,
}
